/**
 * Collections API - Embed
 *
 * Get embeddable collection and media endpoints.
 */

import { z } from 'zod'
import { PaginationMetaSchema } from '../common'
import { CollectionSchema, EmbedLayoutSchema } from './common'
import { CollectionMediaItemSchema } from './media'

// ============================================================================
// GET /v1/collections/embed/:token
// ============================================================================

export const GetEmbedCollectionResponseSchema = z.object({
  data: z.object({
    collection: CollectionSchema,
    embedSettings: z.object({
      layout: EmbedLayoutSchema,
      themeColor: z.string().nullable().optional(),
      showMetadata: z.boolean()
    })
  }),
  message: z.string()
})

export type GetEmbedCollectionResponse = z.infer<typeof GetEmbedCollectionResponseSchema>

// ============================================================================
// GET /v1/collections/embed/:token/media
// ============================================================================

export const GetEmbedMediaResponseSchema = z.object({
  data: z.array(CollectionMediaItemSchema),
  message: z.string(),
  meta: PaginationMetaSchema
})

export type GetEmbedMediaResponse = z.infer<typeof GetEmbedMediaResponseSchema>
